export default __webpack_public_path__ + "static/media/kitchen3-afterD-768w.c0648e73.avif";